import {
  Component,
  computed,
  ContentChild,
  input,
  output,
  TemplateRef,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DataView, DataViewPageEvent } from 'primeng/dataview';
import { IftaLabelModule } from 'primeng/iftalabel';
import { PaginatorModule } from 'primeng/paginator';
import { Select } from 'primeng/select';
import { ListingItemModel } from '../../../../domain/models/listing.model';
import { CommonModule } from '@angular/common';
import {
  ORDER_BY_SPLIT_CHAR,
  ORDER_OPTIONS,
  SORT_BY_COLUMNS,
} from '../../constants/listing-sorting';

const sortByOptions = [
  {
    label: 'Дата най-нови',
    value: `${SORT_BY_COLUMNS.created_at}${ORDER_BY_SPLIT_CHAR}${ORDER_OPTIONS.desc}`,
  },
  {
    label: 'Дата най-стари',
    value: `${SORT_BY_COLUMNS.created_at}${ORDER_BY_SPLIT_CHAR}${ORDER_OPTIONS.asc}`,
  },
  {
    label: 'Цена възходяща',
    value: `${SORT_BY_COLUMNS.price}${ORDER_BY_SPLIT_CHAR}${ORDER_OPTIONS.asc}`,
  },
  {
    label: 'Цена низходяща',
    value: `${SORT_BY_COLUMNS.price}${ORDER_BY_SPLIT_CHAR}${ORDER_OPTIONS.desc}`,
  },
];

@Component({
  selector: 'otw-listing-dataview',
  standalone: true,
  imports: [
    CommonModule,
    PaginatorModule,
    Select,
    FormsModule,
    IftaLabelModule,
    DataView,
  ],
  templateUrl: './listing-dataview.component.html',
  styles: ``,
})
export class ListingDataviewComponent {
  @ContentChild('listing', { read: TemplateRef })
  listingTemplate!: TemplateRef<any>;
  @ContentChild('listingLoading', { read: TemplateRef })
  listingLoadingTemplate!: TemplateRef<any>;
  @ContentChild('headerExtra', { read: TemplateRef })
  headerExtraTemplate!: TemplateRef<any>;

  listings = input.required<ListingItemModel[]>();
  sortBy = input('');
  pageIndex = input<number>(0);
  pageSize = input<number>(10);
  first = computed(() => this.pageIndex() * this.pageSize());
  totalRecords = input<number>(0);
  showPagination = input<boolean>(true);
  showSorting = input<boolean>(true);
  sortByOptions = input<{ label: string; value: string }[]>(sortByOptions);
  headerContainerClass = input<string>('');
  loading = input<boolean>(false);
  loadingSkeletons = computed(() => {
    return Array.from({ length: this.pageSize() });
  });
  layout = input<'list' | 'grid'>('list');

  onChange = output<{ pageIndex: number; sortBy: string }>();

  // TODO: Not sure if this should be a single event or 2 separate events
  onSortByChange(value: string) {
    // reset page when sorting changes
    this.onChange.emit({ pageIndex: 0, sortBy: value });
  }

  onPageChange(event: DataViewPageEvent) {
    if (event.first == undefined || !event.rows) return;
    const nextPageIndex = event.first / event.rows;
    this.onChange.emit({ pageIndex: nextPageIndex, sortBy: this.sortBy() });
  }
}
